<template>
  <div class="file-item upload-item" @click="handleClick">
    <div class="thumb-icon">
      <svg-icon :icon="item.type_icon" cls="type-icon"></svg-icon>
    </div>
    <div class="item-main has-border-bottom">
      <div class="item-name pre-ellipsis">
        <span class="name pre-ellipsis">{{item.name}}</span>
        <span class="loaded" v-if="loaded">{{loaded}} / {{total}}</span>
      </div>
      <div v-if="uploadError" class="error-info"><svg-icon icon="warning" cls="type-icon"/>{{ $t('file.upload.tryAgain', [uploadError]) }}</div>
      <div v-else-if="!loaded" class="waiting-info">{{ $t('file.upload.waiting') }}</div>
      <progress v-else-if="percent" id="progressbar" :value="percent" max="100"></progress>
    </div>
    <div class="item-action has-border-bottom" @click="cancelUpload">
      <i class="iconfont icon-close-small"/>
    </div>
  </div>
</template>
<script>
import { i18n } from '@/utils/i18n'
import ajax from '@/utils/ajax'
import { FILE_INFO } from '@/config/api'
import { Dialog } from 'vant'
import { normalizeFile, normalizeUploadedFileWithAccessToken } from '@/utils/fileUtils'
import { approxSize, handleUploadLog } from '@/utils/common'
import upload, { uploadErrorHandle, fetchUploadFile } from '@/utils/upload'
import config from '@/config'

export default {
  name: 'UploadItem',
  i18n,
  components: {
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    cancelWithMercy: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      percent: 0,
      total: '',
      loaded: '',
      uploadError: false,
      req: null
    }
  },
  created () {
    this.handleH5Upload()
    this.$bus.$on('on-reUpload', this.reUploadIfNeeded)
  },
  updated () {
  },
  beforeDestroy () {
    // 这里销毁所有其他uploadItem就没法接受事件了，需要给出解决方案
    // 此处暂时不取消监听，可以放在父组件beforeDestroy处取消监听，但不是最好方案
    // 最好方案是能够在中间转发事件，做到监听一类，取消单个
    // this.$bus.$off('on-reUpload')
  },
  watch: {
    uploadError (newValue, oldValue) {
      if (typeof newValue === 'string') {
        this.item.error_msg = newValue
      } else {
        this.item.error_msg = undefined
      }
    }
  },
  methods: {
    handleH5Upload () {
      const {uploadTarget, typed_id, fileData, file_id, remark} = this.item
      const target = uploadTarget && uploadTarget.split('_')

      let param = {
        'file_size': fileData.size,
        'file_name': fileData.name
      }

      if (remark) param.remark = remark
      if (file_id) {
        // upload new version
        param.target_file_id = file_id
        // param.remark = '';
      } else if (target) {
        // 不是开放平台专属账号模式下的上传走原逻辑，是的话由upload.js补充参数
        if (!config.isOpenPlatformWithToken) {
          param[target[0] === 'folder' ? 'folder_id' : 'department_id'] = target[1] - 0
        }
      }

      const listeners = {
        onProgress: (e) => {
          this.percent = parseInt(e.percent)
          this.total = approxSize(e.total)
          this.loaded = approxSize(e.loaded)
        },
        onSuccess: (res) => {
          this.handleUploaded(res)
        },
        onError: (e) => {
          if (e.errorType === 'readFailed') {
            this.removeUploadFile(typed_id)
          } else {
            this.uploadError = i18n.t('file.syncUploadError.network')
            // 上传过程中出错了，告诉上层
            this.$emit('item-error', typed_id)
          }
        },
        onAbort: (e) => {
        }
      }
      let options = Object.assign({
        requestId: typed_id,
        param,
        file: fileData
      }, listeners)
      this.req = upload(options).then((res) => this.checkError(res))
    },
    cancelUpload (e) {
      e.stopPropagation()
      if (!this.cancelWithMercy) {
        this.cancelUploadWithNoMercy()
      } else {
        Dialog.alert({
          title: '确定清除该文件吗？',
          message: '未成功上传的文件不会被保留',
          lockScroll: true,
          messageAlign: 'center',
          confirmButtonText: '清除',
          cancelButtonText: '下次再说',
          showConfirmButton: true,
          showCancelButton: true
        }).then((action) => {
          this.cancelUploadWithNoMercy()
        }).catch(_ => {})
      }
    },
    cancelUploadWithNoMercy () {
      this.req && this.req.then(request => {
        request && request.abort && request.abort()
      })
      this.removeUploadFile(this.item.typed_id)
    },
    removeUploadFile (typed_id) {
      this.uploadError = false
      this.percent = 0
      this.$emit('item-delete', typed_id)
    },
    reUpload () {
      this.uploadError = false
      this.handleH5Upload()
      this.$emit('item-reUpload', this.item.typed_id)
    },
    reUploadIfNeeded () {
      if (this.uploadError) {
        this.reUpload()
      }
    },
    handleClick () {
      if (this.uploadError) {
        this.reUpload()
      }
    },
    checkError (res) {
      if (res) {
        const { errors } = res
        if (errors) {
          if (errors === 'presign_permission_denied') {
            this.removeUploadFile(this.item.typed_id)
          } else {
            this.uploadError = errors.error_tr_msg
          }
          // 上传预签名过程中出错了，告诉上层
          this.$emit('item-error', this.item.typed_id)
          return null
        } else {
          return res
        }
      } else {
        this.uploadError = i18n.t('base.failToFetch')
      }
      return res
    },

    handleUploaded (res) {
      const upload_id = this.item.typed_id

      if (res.success && res.new_file) {
        const { typed_id } = res.new_file
        // need path when upload new version in search list
        if (fetchUploadFile.indexOf(typed_id) === -1) {
          let new_file = res.new_file
          if (config.isOpenPlatformWithToken) {
            normalizeUploadedFileWithAccessToken(new_file)
            this.$emit('item-uploaded', new_file, upload_id)
          } else {
            // TODO add
            ajax({
              url: `${FILE_INFO}?item_typed_id=${typed_id}&scenario=isolation`,
              parser: (data) => {
                normalizeFile(data.item)
                if (data && data.success) {
                  const { item } = data
                  if (item.scanned && item.scanned > 0) item.scanned = 1
                  this.$emit('item-uploaded', item, upload_id)
                }
              }
            })
          }
        }
        handleUploadLog(this.item, res.new_file)
      } else {
        // error set uplad reUpload
        const errMsg = uploadErrorHandle(res)
        this.uploadError = errMsg || i18n.t('file.syncUploadError.unknown')
      }
    }

  }
}
</script>

<style lang="postcss">

</style>
